angular
  .module('qkr')
  .controller('PartnersController', function(
    $scope,
    $uibModal,
    partners,
    categories,
    partnerService,
    messageService,
    systemSettingsService,
    appConfig
  ) {
    const vm = this;

    vm.newPartnerName = '';
    vm.newPartnerNotificationResource = '';
    vm.allowedCreateMerchant = true;
    vm.allowedBusinessCategories = [];
    vm.isPosType = false;
    vm.createPartner = false;
    vm.createUsersInMasterPass = true;

  const errorPartnerCallBack = function(error) {
      messageService.errorWithReason(error.data.exception, '', true);
  };

    vm.createNewPartner = function(inValid) {
      if (!inValid) {
        vm.updateAllowedBusinessCategory();
        partnerService
          .create(
              vm.newPartnerName,
              vm.allowedCreateMerchant,
              vm.allowedBusinessCategories,
              vm.isPosType,
              vm.createUsersInMasterPass
          ).then(partner => {
            vm.updatePartners(partner);
          }).catch(errorPartnerCallBack);
      }
    };

    vm.updatePartners = function (partner) {
        vm.clearNewPartner();
        vm.partners.push(partner)
    };

    vm.listPartners = function() {
        vm.clearNewPartner();
        vm.partners = partners;
    };

    vm.clearNewPartner = function() {
      vm.createPartner = false;
      vm.newPartnerName = '';
      vm.newPartnerNotificationResource = '';
    };

    $scope.editPartner = function(index) {
      const partner = vm.partners[index];

      const modalInstance = $uibModal.open({
        template: require('../../templates/partners/partner.html'),
        controller: 'PartnerModalDialogController',
        windowClass: 'modal-huge',
        backdrop: 'static',
        resolve: {
          userAction() {
            return 'edit';
          },
          partner() {
            return partnerService.getPartner(partner.id);
          },
          businessCategories() {
            return systemSettingsService.loadBusinessCategories();
          }
        }
      });

      modalInstance.result.then(
        result => {
          if (result == 'done') {
            vm.listPartners();
          }
        },
        () => {}
      ).catch(errorPartnerCallBack);
    };

    vm.updateAllowedBusinessCategory = function() {
      vm.businessCategories.forEach (businessCategory => {
        if (businessCategory.selected) {
          vm.allowedBusinessCategories.push(businessCategory.id)
        }
      });
    };

    vm.listBusinessCategories = function () {
        if (appConfig.isMCAdmin) {
          vm.businessCategories = categories;
        }
    };

    vm.listPartners();
    vm.listBusinessCategories();
  });



// WEBPACK FOOTER //
// ./src/controllers/mastercard/partners.controller.js